import { useMemo } from "react";

import { useQueryParam, withDefault } from "use-query-params";

import { CustomJsonCompressedParam } from "@north-beam/nb-common";
import { useAdoptedMix } from "@pages/mmm/hooks/use-adopted-mix";
import { useBudgetMixes } from "@pages/mmm/hooks/use-budget-mixes";

export const getInitialHiddenBudgetMixes = () => ["-1"];

export const BUDGET_MIX_TARGET_SPEND = "Target Spend";

export const useHiddenBudgetMixes = () => {
  const [budgetMixes] = useBudgetMixes();
  const [adoptedMixData] = useAdoptedMix();
  const [_hiddenBudgetMixes, setHiddenBudgetMixes] = useQueryParam(
    "hidden-mixes",
    withDefault<string[], string[]>(
      CustomJsonCompressedParam<string[]>(),
      getInitialHiddenBudgetMixes(),
    ),
  );

  const [budgetStrategies, setBudgetStrategies] = useQueryParam(
    "budget-strategies",
    withDefault<string[], string[]>(CustomJsonCompressedParam<string[]>(), [
      BUDGET_MIX_TARGET_SPEND,
    ]),
  );

  const [hiddenClientSettings, setHiddenClientSettings] = useQueryParam(
    "hidden-client-settings",
    withDefault<Record<string, boolean>, Record<string, boolean>>(
      CustomJsonCompressedParam<Record<string, boolean>>(),
      {},
    ),
  );

  const hiddenBudgetMixes = useMemo(() => {
    const unadoptedAndNonCustomBudgetMixes = budgetMixes.filter(
      (budget) => budget.id !== adoptedMixData?.id && !budget.is_custom,
    );
    const budgetMixesToHide = unadoptedAndNonCustomBudgetMixes.filter(
      (budgetMix) =>
        !budgetStrategies.includes(budgetMix.name || "") ||
        hiddenClientSettings[budgetMix.client_setting_id],
    );

    const budgetMixIdsToHide = budgetMixesToHide.map((budgetMix) =>
      String(budgetMix.id),
    );

    return budgetMixIdsToHide;
  }, [
    _hiddenBudgetMixes,
    adoptedMixData?.id,
    budgetMixes,
    budgetStrategies,
    hiddenClientSettings,
  ]);

  return [
    hiddenBudgetMixes,
    setHiddenBudgetMixes,

    {
      setBudgetStrategies,
      budgetStrategies,
      hiddenClientSettings,
      setHiddenClientSettings,
    },
  ] as const;
};
